import produce from 'immer';

import {
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED,
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START,
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS
} from '@redux/actions/bopis/getBOPISFreeGiftAvailabilityStores/types';

const initialState = {
  isFetchingStores: false,
  data: [],
  error: null
};

const getBOPISFreeGiftAvailabilityStoresReducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
  case GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START:
    draft.isFetchingStores = true;

    draft.error = null;
    break;

  case GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS:
    draft.isFetchingStores = false;

    draft.data = [
      ...(
          action.payload?.ListAvailablityStores || []
      )].sort((a, b) => {
      if (a.Name > b.Name) return 1;
      if (a.Name < b.Name) return -1;

      return 0;
    });
    break;

  case GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED:
    draft.isFetchingStores = false;

    draft.error = action.payload;
    break;
  }

  return draft;
});

export default getBOPISFreeGiftAvailabilityStoresReducer;